import * as React from 'react'
import * as TabsPrimitive from '@radix-ui/react-tabs'

import { cn } from '~/shadcn/lib/utils'

function Tabs({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      className={cn('flex flex-col gap-2', className)}
      {...props}
    />
  )
}

function TabsList({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        'bg-muted text-muted-foreground inline-flex w-fit items-center justify-center rounded-lg',
        className
      )}
      {...props}
    />
  )
}

const underlineStyles = [
  'after:content-[""] after:absolute after:bottom-0 after:left-0',
  'after:w-full after:h-0.5 after:z-[1]',
  'after:bg-accent after:origin-center',
  'after:transition-all after:duration-300',
]

interface TabsTriggerProps
  extends React.ComponentProps<typeof TabsPrimitive.Trigger> {
  isActive?: boolean
}

function TabsTrigger({
  className,
  isActive = false,
  ...props
}: TabsTriggerProps) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        "cursor-pointer inline-flex h-full flex-1 items-center justify-start gap-2 rounded-md pt-3 pr-6 pb-7 pl-3 text-base font-semibold whitespace-nowrap focus-visible:ring-[3px] focus-visible:outline-1 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        'relative rounded-none',
        'transition-none',
        ...underlineStyles,
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring',
        isActive
          ? 'text-accent after:opacity-100 after:scale-x-100'
          : 'text-muted-foreground after:opacity-0 after:scale-x-0 hover:after:opacity-100 hover:after:scale-x-100',
        className
      )}
      {...props}
    />
  )
}
function TabsContent({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn('flex-1 outline-none', className)}
      {...props}
    />
  )
}

export { Tabs, TabsList, TabsTrigger, TabsContent }
